// extracted by mini-css-extract-plugin
export default {"plan-card":"DisplayPlanCard_plan-card__BbvCe","plan-title":"DisplayPlanCard_plan-title__mu68g"};